import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import ManualTransactionEditContext from "context/ManualTransactionEditContext";
import { getTransactionChangeByIdAsync } from "state/slices/initiateTransactionChange";
import { getCompany } from "state/slices/company";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import UpdateCompanyDetails from "components/CompanyDashboard/MaintainYourCompany/UpdateCompanyDetails";
import { ManageModuleContext } from "context/ManageCompanyModuleContext";
import UpdateHistory from "components/CompanyDashboard/UpdateHistory";

const ManualTransactionEdit = () => {
  const { trxId, companyId } = useParams();
  const [transactionToEdit, setTransactionToEdit] = useState("");
  const dispatch = useDispatch();
  const isInManualTransactionEditContext = true;

  const { getTransactionById, initiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );

  const [status, setStatus] = useState(getTransactionById.status);
  const [refechTransactionOnEditContext, setRefechTransactionOnEditContext] =
    useState(false);
  const [changeOfParticularsInfo, setChangeOfParticularsInfo] = useState({
    selectedValueType: "",
  });

  useEffect(() => {
    dispatch(getCompany({ id: companyId }));
  }, [companyId]);

  useEffect(async () => {
    if (!transactionToEdit) {
      const response = await dispatch(getTransactionChangeByIdAsync({ trxId }));
      if (response.payload.status) {
        setTransactionToEdit(response.payload.retrievedTransactions);
      }
    }
  }, [trxId, refechTransactionOnEditContext]);

  if (status === "loading") {
    return (
      <>
        <CompanyDashboardWrapper>
          <ManualTransactionEditContext.Provider
            value={{
              isInManualTransactionEditContext,
            }}
          >
            <SpinnerIcon />
          </ManualTransactionEditContext.Provider>
        </CompanyDashboardWrapper>
      </>
    );
  }
  if (status === "idle" && transactionToEdit) {
    return (
      <CompanyDashboardWrapper isForHistory={transactionToEdit?.isForHistory}>
        <ManageModuleContext.Provider
          value={{
            changeOfParticularsInfo,
            setChangeOfParticularsInfo,
          }}
        >
          <ManualTransactionEditContext.Provider
            value={{
              isInManualTransactionEditContext,
              transactionToEdit,
              setTransactionToEdit,
              setRefechTransactionOnEditContext,
            }}
          >
            {transactionToEdit?.isForHistory ? (
              <UpdateHistory />
            ) : (
              <UpdateCompanyDetails />
            )}
          </ManualTransactionEditContext.Provider>
        </ManageModuleContext.Provider>
      </CompanyDashboardWrapper>
    );
  }
  if (status === "failed") {
    return (
      <>
        <span>Failed to get resources..</span>
      </>
    );
  }
  return (
    <>
      <CompanyDashboardWrapper>
        <ManualTransactionEditContext.Provider
          value={{
            isInManualTransactionEditContext,
          }}
        >
          <SpinnerIcon /> Getting data...
        </ManualTransactionEditContext.Provider>
      </CompanyDashboardWrapper>
    </>
  );
};

export default ManualTransactionEdit;
